<script setup lang="ts">
import { onMounted, ref } from "vue";

import MocaSmart from "../../assets/claim/moca-smart.svg";
import { config } from "../../config";
import MetamaskLoginFactory from "../../handlers/Auth/MetamaskFactory";
import { useClaimStore } from "../../store/claimStore";
import { useControllerStore } from "../../store/controllerStore";
import ConnectMetaMaskError from "./ConnectMetaMaskError.vue";
import NoEligibleMoca from "./NoEligibleMoca.vue";

const claimStore = useClaimStore();
const controllerStore = useControllerStore();
const noMocaFound = ref(false);
const shouldRetry = ref(false);

async function signMessageForMoca(ethProvider: any) {
  try {
    const address = ethProvider.selectedAddress;
    claimStore.mocaNFTAddress = address;
    const result = await ethProvider.request({
      method: "personal_sign",
      params: [config.mocaIDSignMessage, address],
    });
    claimStore.mocaSignature = result as string;
    const hasEligibleMoca = await claimStore.verifyContainEligibleNFT({ address });
    if (!hasEligibleMoca) {
      noMocaFound.value = true;
    }
  } catch (error) {
    shouldRetry.value = true;
  }
}

async function connectMetamask() {
  shouldRetry.value = false;
  const metamask = await MetamaskLoginFactory.getInstance({
    providerConfig: controllerStore.networkProviderConfig,
    onLogout: controllerStore.logout,
  });
  if (metamask.connnected && !claimStore.mocaSignature) {
    signMessageForMoca(metamask.provider);
    return;
  }
  try {
    await metamask.connect();
    signMessageForMoca(metamask.provider);
  } catch (error) {
    if (metamask.connnected && !claimStore.mocaSignature) {
      signMessageForMoca(metamask.provider);
      return;
    }
    shouldRetry.value = true;
  }
}

onMounted(() => {
  connectMetamask();
});
</script>

<template>
  <ConnectMetaMaskError v-if="shouldRetry" @on-retry="connectMetamask" />
  <NoEligibleMoca v-if="noMocaFound" />
  <div v-if="!noMocaFound && !shouldRetry" class="flex flex-col justify-center items-center gap-6 h-[428px]">
    <img :src="MocaSmart" />
    <p class="text-white text-xl font-bold text-center">Let's connect wallet...</p>
    <p class="text-moca-white-80 text-base font-medium text-center">To see how many Mocas you have and how many extra invite codes you can get.</p>
  </div>
</template>
